import { createReducer } from 'typesafe-actions';

import * as actions from './actions';
import { SelectedBookingState } from './types';

export const getInitialState = (): SelectedBookingState => ({ transactionUuid: null, hasLocalSelection: false });

export const initialState: SelectedBookingState = getInitialState();

const setSelectedBookingHandler = (
  state: SelectedBookingState,
  { payload }: ReturnType<typeof actions.setSelectedBooking>,
): SelectedBookingState => ({ ...state, transactionUuid: payload || null, hasLocalSelection: true });

/**
 * ⛔ THE TENANT WINS. A stored selection that arrives after they have opened something else -- or
 * closed what they had -- is an answer to a question that stopped being current, and applying it
 * would reopen the booking they just left.
 *
 * It does NOT mark the slice as locally chosen: hydration is the host talking, not the tenant, and
 * a second answer to the same boot question should be allowed to land the same way the first was.
 */
const hydrateSelectedBookingHandler = (
  state: SelectedBookingState,
  { payload }: ReturnType<typeof actions.hydrateSelectedBooking>,
): SelectedBookingState => (state.hasLocalSelection ? state : { ...state, transactionUuid: payload || null });

const selectedBookingReducer = createReducer(initialState)
  .handleAction(actions.setSelectedBooking, setSelectedBookingHandler)
  .handleAction(actions.hydrateSelectedBooking, hydrateSelectedBookingHandler);

export default selectedBookingReducer;
